import React from "react";
import Layout from "../components/layout";

const Contact = () => (
  <Layout
    title="Contact"
    metaDescription="Contact us for technical support, sales and licensing questions, or just to say hi!"
  >
    <p>
      For technical support: <br />
      <a href="mailto:help@summerbell.com">help@summerbell.com</a>
    </p>
    <p>
      For sales, licensing, or other inquiries: <br />
      <a href="mailto:info@summerbell.com">info@summerbell.com</a>
    </p>
    <p>
      To get in touch with our founder: <br />
      <a href="mailto:hillary@summerbell.com">hillary@summerbell.com</a>
    </p>
  </Layout>
);

export default Contact;
